var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoodStroke1 = function SvgMoodStroke1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54.442,
    height: 54.442,
    viewBox: "0 0 54.442 54.442",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_727",
    "data-name": "Caminho 727",
    d: "M130.657,91.725a23.815,23.815,0,1,0-13.105-12.667,23.763,23.763,0,0,0,13.105,12.667Zm19.582,2.8a27.2,27.2,0,1,1,14.486-14.977A27.119,27.119,0,0,1,150.239,94.528ZM139.406,81.773H128.892A1.693,1.693,0,0,1,127.2,80.08a12.207,12.207,0,1,1,24.413,0,1.693,1.693,0,0,1-1.693,1.693H139.406Zm-8.657-3.386h17.312a8.821,8.821,0,0,0-17.312,0Z",
    transform: "translate(-112.185 -42.345)",
    stroke: "none"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoodStroke1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moodStroke1.bf2ddc81.svg";
export { ForwardRef as ReactComponent };